import { useEffect, useRef, useState } from 'react';

const useRecaptcha = () => {
  const [loaded, setLoaded] = useState(false);
  const siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY;
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    if (!siteKey) {
      console.warn('REACT_APP_GOOGLE_RECAPTCHA_SITEKEY is not set');
      return;
    }

    const existingScript = document.getElementById('recaptcha-script');
    if (existingScript) {
      setLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.id = 'recaptcha-script';
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;

    script.onload = () => setLoaded(true);
    script.onerror = () => console.error('Failed to load reCAPTCHA');

    document.body.appendChild(script);

    return () => {
      isMounted.current = false;
      let attempts = 0;
      const maxAttempts = 10; // ~1 second total
      const interval = setInterval(() => {
        // Remove main script
        const scriptEl = document.getElementById('recaptcha-script');
        if (scriptEl) scriptEl.remove();

        // Remove all recaptcha-related scripts except the main one
        document.querySelectorAll('script[src*="recaptcha"]').forEach((recaptchaScript) => {
          if (recaptchaScript.id !== 'recaptcha-script') {
            recaptchaScript.parentNode && recaptchaScript.parentNode.removeChild(recaptchaScript);
          }
        });

        // Remove all reCAPTCHA badges
        document.querySelectorAll('.grecaptcha-badge').forEach((badge) => {
          badge.parentNode && badge.parentNode.removeChild(badge);
        });

        // Remove grecaptcha from window
        if ((window as any).grecaptcha) delete (window as any).grecaptcha;

        attempts = attempts + 1;
        if (attempts >= maxAttempts) {
          clearInterval(interval);
          if (isMounted.current) setLoaded(false);
        }
      }, 100);
    };
  }, [siteKey]);

  return loaded;
};

export default useRecaptcha;
